var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.texts != null)?_c('div',_vm._l((_vm.texts),function(t,idx){return _c('section',{key:idx,staticClass:"content u-p1",domProps:{"innerHTML":_vm._s(t)}})}),0):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }